import { ToggleButton as MuiToggleButton } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { CheckIcon } from "@phosphor-icons/react";
import { type MouseEvent, type ReactNode } from "react";

const LIST_TOGGLE_BUTTON_SX: SxProps<Theme> = {
  border: "none",
  borderBottom: "1px solid var(--color-stroke-neutral-soft)",
  borderRadius: "0",
  textTransform: "unset",
  padding: "16px 8px",
  "&.Mui-selected": {
    backgroundColor: "transparent",
    color: "inherit",
  },
  // Keep this explicit override so selected+hover doesn't fall back to MUI's default selected hover color.
  "&.Mui-selected:hover": {
    backgroundColor: "var(--color-surface-neutral-soft)",
  },
  "&:hover": {
    backgroundColor: "var(--color-surface-neutral-soft)",
  },
};

type Props = {
  value: string;
  onChange?: (event: MouseEvent<HTMLElement>, value: string) => void;
  children: ReactNode;
  selected?: boolean;
};

export function ListToggleButton({
  value,
  onChange,
  selected,
  children,
}: Props) {
  return (
    <MuiToggleButton
      onChange={onChange}
      selected={selected}
      value={value}
      sx={LIST_TOGGLE_BUTTON_SX}
    >
      <div className="flex w-full">
        <span className="inline-flex grow items-center gap-4 text-base font-medium text-text-primary">
          {children}
        </span>

        {selected ? (
          <CheckIcon
            size={20}
            className="fill-text-interactive"
            weight="bold"
          />
        ) : null}
      </div>
    </MuiToggleButton>
  );
}
